import React from 'react'
import ProjectLoop from './project-loop'
class RelatedProjects extends React.Component {
    render(){
        return(
            <ProjectLoop title="Related Projects" max="3"/>
        )
    }
}

export default RelatedProjects